import { inject, InjectionToken, Renderer2, RendererFactory2, Signal, signal, WritableSignal } from '@angular/core';
import { WINDOW } from './window';
import { PlatformService } from '../services/platform/platform.service';

export const events: string[] = ['mousemove', 'keydown', 'scroll'];

const isSiteInteract = (): Signal<boolean> => {
  const window = inject(WINDOW);
  const rendererFactory2 = inject(RendererFactory2);
  const platformService = inject(PlatformService);
  const renderer: Renderer2 = rendererFactory2.createRenderer(null, null);

  const isInteract: WritableSignal<boolean> = signal(false);

  const eventListeners: (() => void)[] = [];

  if (platformService.isBrowser) {
    events.forEach((event: string) => {
      eventListeners.push(
        renderer.listen(window, event, () => {
          onInteract();
        })
      );
    });

    const onInteract = () => {
      console.info(`onInteract`);
      eventListeners.forEach((destroyFn) => destroyFn());
      isInteract.set(true);
    };
  } else {
    console.info(`onInteract server`);
    isInteract.set(true);
  }

  return isInteract;
};

export const IS_SITE_INTERACT = new InjectionToken<Signal<boolean>>('Detect when user interact with site', {
  providedIn: 'root',
  factory: () => isSiteInteract(),
});
